module.exports = __webpack_public_path__ + "static/media/text_icon_rectangle.59c95fbe.svg";